import { useFlags } from '@local/do-secundo-feature-flags'
import { InfoIcon } from '@toasttab/buffet-pui-icons'
import { Modal, ModalBody, ModalHeader } from '@toasttab/buffet-pui-modal'
import React, { useEffect, useState } from 'react'
import { t, Trans } from '@local/translations'

export const InstagramWarning = () => {
  const [showBrowserWarning, setShowBrowserWarning] = useState(false)

  useEffect(() => {
    const userAgent = (navigator.userAgent || navigator.vendor).toLowerCase()
    if (/instagram/i.test(userAgent) && /iphone|ipad|ipod/i.test(userAgent)) {
      setShowBrowserWarning(true)
    }
  }, [])

  const { nvsCooRecaptcha } = useFlags()
  if (!nvsCooRecaptcha) return <></>

  return (
    <Modal
      isOpen={showBrowserWarning}
      onRequestClose={() => setShowBrowserWarning(false)}
    >
      <ModalHeader>
        <Trans
          i18nKey='instagram-warning.please-note'
          components={{
            Icon: <InfoIcon accessibility='decorative' />
          }}
        />
      </ModalHeader>
      <ModalBody>
        {t('instagram-warning.payment-blocked-message')}
        <div className='pt-4'>{t('instagram-warning.click-triple-dot')}</div>
        <img
          className='object-cover pb-4 rounded-md'
          src={
            'https://cdn.toasttab.com/static/30e1c4ecbc5210c07ce177c178836540736c1735/projects/new-ventures/catering/coo_instagram_popup_1.png'
          }
          alt={t('instagram-warning.instagram-triple-dot-alt')}
        />
        {t('instagram-warning.choose-external-browser')}
        <img
          className='object-cover pb-4 rounded-md'
          src={
            'https://cdn.toasttab.com/static/30e1c4ecbc5210c07ce177c178836540736c1735/projects/new-ventures/catering/coo_instagram_popup_2.png'
          }
          alt={t('instagram-warning.open-in-external-browser-alt')}
        />
        <div className='pt-2'>{t('instagram-warning.thank-you-message')}</div>
      </ModalBody>
    </Modal>
  )
}
